import { EN_KO, TAO_KOE } from './../libs';
import Shop from './shop';

const ShopBrands = {};

// Update Brands in Brandslider.
ShopBrands.initBrandFilter = function() {
	// Check if Listpage.
	const facetEl = document.getElementById( 'offcanvas_facet_filter' );
	if ( ! facetEl ) {
		return false;
	}

	const brandSliderEls = document.querySelectorAll( '.en_mdl_brandslider' );
	if ( brandSliderEls.length <= 0 ) {
		return false;
	}

	const filterGroup = Shop.getFilterGroup( 'brands' );
	if ( ! filterGroup ) {
		return false;
	}

	brandSliderEls.forEach( ( wrapperEl ) => {
		const bouncer = EN_KO.lodash.debounce( () => wrapperEl.dispatchEvent( new CustomEvent( 'carouselUpdateItems.sl', { bubbles: true } ) ), 250 );
		let counter = 0;

		// No Filter JSON - No Data.
		const filters = filterGroup.filter;
		if ( 0 === filters.length ) {
			return;
		}

		// Check if brandslider is not in menu flyout
		if ( wrapperEl.closest( '.site_inner' ) === null ) {
			return;
		}

		// Check all links.
		const linkEls = wrapperEl.querySelectorAll( 'a[data-pimid]' );
		linkEls.forEach( ( linkEl ) => {
			// Check identifier on the Link.
			const brandName = linkEl.dataset.brandname;
			if ( ! brandName ) {
				return true;
			}

			// Look for the filter in the current filterJSON.
			const foundFilter = filters.find( ( filter ) => {
				const label = filter.label;
				const split = filter.value.split( '$$' );

				return label === brandName || split[ 0 ] === brandName;
			} );

			// No Filter found => Hide me.
			if ( ! foundFilter ) {
				// Hide Parent Element.
				linkEl.parentElement.classList.add( 'en_hidden' );

				// Recalculate Slider Arrows.
				bouncer();
			} else {
				// counts the visible brands.
				counter++;
			}
		} );

		// Hides the parent class if exist.
		if ( counter < 3 ) {
			const teaserEl = wrapperEl.closest( '.en_mdl_productlistteaser' ) || wrapperEl.closest( '.mdl_block_acf-markenslider' ) || wrapperEl;
			if ( teaserEl ) {
				teaserEl.classList.add( 'en_hidden' );
			}
		}
	} );

	return true;
};

// Init.
TAO_KOE.ready( 'shop-brands.js', () => ShopBrands.initBrandFilter() );

// Expose.
Shop.Brands = ShopBrands;
export default ShopBrands;
